module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-pdf-fill-0f4ae386.svg";